import React, {useEffect} from "react";
import { useDispatch } from "react-redux";
import { panelUserLogout } from "../actions/loginActions";
import snackBarUpdate from "../actions/snackBarActions";
import Prefix from "../config/ApiPrefix";
import SecureStorage from "../config/SecureStorage";
import Api from "../helpers/api";

export interface UserPrviderData {
    profile: Profile | null;
    token: string | null;
    loading: boolean;
    login: (data: any) => Promise<void>;
    logout: () => void;
    hasPermission: (permission: string) => boolean;
}

const UserContext = React.createContext<UserPrviderData>({
    profile: null,
    token: null,
    loading: false,
    login: () => Promise.reject('Not implemented'),
    logout: () => {throw new Error("logout not implemented")},
    hasPermission: (permission: string) => {return false}
});

export interface UserProviderProps {
    children?: React.ReactNode;
}

export interface Profile {
    _id: string;
    uuid: string;
    fullname: string;
    image: string;
    username: string;
    email?: string;
    password_change: boolean;
    usergroup: string;
    address?: string;
    age?: number;
    designation?: string;
    dob?: Date;
    gender?: string;
    pilot_user?: boolean;
    executive_type?: string;
    permissions: string[];
    clients: string[];
    scientist?: any;
}


export const UserProvider = ({ children }: UserProviderProps) => {
    const dispatch = useDispatch();
    const [profile, setProfile] = React.useState<Profile | null>(null);
    const [token, setToken] = React.useState<string | null>(SecureStorage.getItem("token"));
    const [init, setInit] = React.useState(true);
    const [loading, setLoading] = React.useState(false);

    const login = async (data: any) => {
        Api.post(`${process.env.REACT_APP_API_PATH}${Prefix.api}/auth/users/login/`, {user: data})
            .then((resp: any) => {
                SecureStorage.setItem("token", resp.user.token);
                setToken(resp.user.token);
            })
            .catch((error: any) => {
                const message = error.response?.errors?.map((error: any) => error.message).join(", ") || "Something went wrong";
                snackBarUpdate({
                    payload: {
                        message,
                        status: true,
                        type: "error",
                    }
                })(dispatch);
                setLoading(false);
            });
    };

    const logout = () => {
        dispatch(panelUserLogout());
        SecureStorage.removeItem("token");
        setToken(null);
        // window.location.replace("/");
    }

    const hasPermission = (permission: string) => 
        profile?.permissions.includes(permission) || false;
    

    useEffect(() => {
        Api.setToken(token);
        if (token) {
            !profile && Api.get('/genomics/me').then((user: any) => {
                setProfile(user.profile);
                SecureStorage.setItem("token", user.token);
                setToken(user.token);
                setLoading(false);
                setInit(false);
            }).catch(() => {
                logout();
                setInit(false);
            });
        }else{
            setProfile(null);
            setInit(false);
        }
    }, [token, profile]);

    if(init) return <div></div>;

    return (
        <UserContext.Provider value={{
            profile,
            token,
            loading,
            login,
            logout,
            hasPermission
        }}>{children}</UserContext.Provider>
    );
}

export const useUser = () => React.useContext(UserContext);
